export default __webpack_public_path__ + "static/media/signal-1.b98c7d6e.svg";